import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import ApprovalRequestAccessModalI18n from '../i18n/ApprovalRequestAccessModalI18n';
import ApprovalRequestAccessModalError from './ApprovalRequestAccessModalError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalRequestAccessModalBody = props => {
  const {
    errorSubCategory,
    isLoading,
    onChangeSelect,
    onChangeMessage,
    superAdminUsersOptions
  } = props;
  const approval = useApprovalContext();
  const onChangeText = evt => {
    onChangeMessage(evt.target.value);
  };
  return /*#__PURE__*/_jsxs(DialogBody, {
    children: [errorSubCategory && /*#__PURE__*/_jsx(ApprovalRequestAccessModalError, {
      approvalType: approval.meta.approvalType,
      errorSubCategory: errorSubCategory
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(ApprovalRequestAccessModalI18n, {
        approvalType: approval.meta.approvalType
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.labels.adminName"
      }),
      required: true,
      children: /*#__PURE__*/_jsx(Select, {
        anchorType: "button",
        "data-test-id": "product-approvals-request-access-admin-select",
        isLoading: isLoading,
        onChange: onChangeSelect,
        options: superAdminUsersOptions,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.placeholders.chooseAdmin"
        })
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.labels.addMessage"
      }),
      children: /*#__PURE__*/_jsx(TextArea, {
        onChange: onChangeText,
        placeholder: I18n.text('productApprovals.placeholders.addMessageOptional')
      })
    })]
  });
};
export default ApprovalRequestAccessModalBody;